import { SagaIterator } from '@redux-saga/core';
import { put, takeLatest, call, all, select } from 'redux-saga/effects';
import { Auth } from 'aws-amplify';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';
import { localRedirect } from 'utils';

import * as Actions from './slice';
import * as Selectors from './selectors';

export function* loginUser(data: RequestSagaParams): SagaIterator {
  try {
    const { email, password } = data.payload;
    const result = yield call([Auth, Auth.signIn], email, password);

    if (result.challengeName === 'NEW_PASSWORD_REQUIRED') {
      yield put(Actions.loginChallengeRequired(result));
      yield call(localRedirect, '/set-password');
      return;
    }

    const user = yield call([Auth, Auth.currentAuthenticatedUser]);
    yield put(Actions.loginSuccess(user.username));
    yield call(localRedirect, '/call-to-action');
  } catch (error: any) {
    yield put(Actions.loginFailed(error?.message));
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
  }
}

export function* setNewPasswordSaga(data: RequestSagaParams): SagaIterator {
  try {
    const challengeUser = yield select(Selectors.makeSelectChallengeUser());
    const { newPassword } = data.payload;
    yield call([Auth, Auth.completeNewPassword], challengeUser, newPassword);
    yield put(Actions.setNewPasswordSuccess());
    yield call(localRedirect, '/call-to-action');
  } catch (error: any) {
    yield put(Actions.setNewPasswordFailed(error?.message));
    yield call(statusMessageSaga, { type: 'error', message: error?.message });
  }
}

export function* authManagementWatcherSaga(): SagaIterator {
  yield all([
    yield takeLatest(Actions.login.type, loginUser),
    yield takeLatest(Actions.setNewPassword.type, setNewPasswordSaga)
  ]);
}

export default authManagementWatcherSaga;
